module.exports = __webpack_public_path__ + "static/media/Nav app card.d81f6b78.png";